import React, { useState, useEffect } from 'react';
import "../../assets/css/filtermodal.css";
import SvgContent from '../../components/Svgcontent';
import axios from 'axios';
import configModule from '../../../config';
import { toast, ToastContainer } from "react-toastify";

function FilterModal({ data, onCloseHandler }) {
    const config = configModule.config();

    const [courseCategory, setCourseCategory] = useState([]);
    const [branches, setBranches] = useState([]);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [exams, setExams] = useState([]);

    const [stateSearch, setStateSearch] = useState("");
    const [citySearch, setCitySearch] = useState("");
    const [branchSearch, setBranchSearch] = useState("");
    const [examsSearch, setExamsSearch] = useState("");

    const [selectedFilters, setSelectedFilters] = useState({
        category: [],
        branches: [],
        state: [],
        city: [],
        exams: [],
        application: []
    });

    const appliAccept = [{ name: "Yes", id: 1 }, { name: "No", id: 0 }];

    useEffect(() => {
        if (data) {
            setSelectedFilters((prev) => ({
                ...prev,
                category: parseMultiSelect(data.category_id, data.category_name),
                branch: parseMultiSelect(data.branch_id, data.branch_name),
                city: parseMultiSelect(data.city_id, data.city_name),
                state: parseMultiSelect(data.state_id, data.state_name),
                exam: parseMultiSelect(data.exam_id, data.exam_name),
                application: data.application
                    ? [{ id: data.application, value: data.application }]
                    : []
            }));
        }
    }, [data]);

    const getFilterData = async () => {
        try {
            const res = await axios.get(`${config.apiBaseUrl}/get-ftrcategory`, {
                headers: {
                    "x-api-key": config?.apichKey
                }
            }
            );

            setCourseCategory(res?.data?.queryCat);
            setBranches(res?.data?.queryBranch);
            setCity(res?.data?.queryCity);
            setState(res?.data?.queryState);
            setExams(res?.data?.queryExams);

        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        getFilterData();
    }, []);

    const handleCheckboxChange = (type, value, recid) => {
        setSelectedFilters((prev) => {
            const alreadySelected = prev[type].some(
                (selected) => selected.value === value
            );

            return {
                ...prev,
                [type]: alreadySelected
                    ? prev[type].filter((item) => item.value !== value)
                    : [...prev[type], { id: recid, value }]
            };
        });
    };

    const parseMultiSelect = (ids, names) => {
        if (!ids || !names) return [];

        const idArray = ids.split(",");
        const nameArray = names.replace(/'/g, "").split(",");

        return idArray.map((id, index) => ({
            id: id.trim(),
            value: nameArray[index]?.trim()
        }));
    };

    const handleApply = () => {
        const hasSelection = Object.values(selectedFilters).some(
            (arr) => arr.length > 0
        );

        if (!hasSelection) {
            toast.warning("Please select at least one filter");
            return;
        }

        const result = {};

        if (selectedFilters.category.length > 0) {
            result.category_id = selectedFilters.category.map(item => item.id).join(",") || "";
            result.category_name = selectedFilters.category.map(item => "'" + item.value + "'").join(",") || "";
        }

        if (selectedFilters.branches.length > 0) {
            result.branch_id = selectedFilters.branches.map(item => item.id).join(",") || "";
            result.branch_name = selectedFilters.branches.map(item => "'" + item.value + "'").join(",") || "";
        }

        if (selectedFilters.state.length > 0) {
            result.state_id = selectedFilters.state.map(item => item.id).join(",") || "";
            result.state_name = selectedFilters.state.map(item => "'" + item.value + "'").join(",") || "";
        }

        if (selectedFilters.city.length > 0) {
            result.city_id = selectedFilters.city.map(item => item.id).join(",") || "";
            result.city_name = selectedFilters.city.map(item => "'" + item.value + "'").join(",") || "";
        }

        if (selectedFilters.exams.length > 0) {
            result.exam_id = selectedFilters.exams.map(item => item.id).join(",") || "";
            result.exam_name = selectedFilters.exams.map(item => "'" + item.value + "'").join(",") || "";
        }

        if (selectedFilters.application.length > 0) {
            result.application = selectedFilters.application.map(item => Number(item.id)).join(",") || "";
        }

        onCloseHandler("filter", result);
    };

    const handleReset = () => {
        setSelectedFilters({
            category: [],
            branches: [],
            state: [],
            city: [],
            exams: [],
            application: []
        });
    };

    const clearFilter = (filterType) => {
        setSelectedFilters((prev) => ({
            ...prev,
            [filterType]: []
        }));
    };

    return (
        <div className="filtermod_overlay" >
            <ToastContainer />
            <div
                className="filtermod_sidebar"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="filtermod_header">
                    <h3 className='mb-0 fm-filtrname-st'>Filters</h3>
                    <span className="aapnow_close" onClick={() => onCloseHandler("close")}>
                        <SvgContent svg_name="close" className="closestyle" />
                    </span>
                </div>

                <div className="filtermod_content">
                    <div className='sf-card mb-3'>
                        <div className="sf-head">
                            <span className="sf-title">Graduation Type</span>
                            <button className="sf-clear" onClick={() => clearFilter("category")}>Clear</button>
                        </div>
                        <div className="sf-body">
                            {courseCategory && courseCategory.map((item) => (
                                <label key={item.id} className="custom-checkbox">
                                    <input type="checkbox"
                                        checked={selectedFilters.category.some(
                                            (selected) => selected.value === item.graduation_type
                                        )}
                                        onChange={() => handleCheckboxChange("category", item.graduation_type, item.id)} />
                                    <span className="checkmark"></span>
                                    <p className='sf-label'>{item.graduation_type}</p>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className='sf-card mb-3'>
                        <div className="sf-head">
                            <span className="sf-title">Branch</span>
                            <button className="sf-clear" onClick={() => clearFilter("branches")}>Clear</button>
                        </div>
                        <input
                            type="text"
                            placeholder="Search Branch"
                            className="filter-search"
                            value={branchSearch}
                            onChange={(e) => setBranchSearch(e.target.value)}
                        />
                        <div className="seicon-st"><SvgContent svg_name="search_icon" stroke="#ababab" /></div>

                        <div className="sf-body">
                            {branches && branches
                                ?.filter((branch) =>
                                    branch.branch.toLowerCase().includes(branchSearch.toLowerCase())
                                ).map((branch) => (
                                    <label key={branch.id} className="custom-checkbox">
                                        <input type="checkbox"
                                            checked={selectedFilters.branches.some(
                                                (selected) => selected.value === branch.branch
                                            )}
                                            onChange={() => handleCheckboxChange("branches", branch.branch, branch.id)} />
                                        <span className="checkmark"></span>
                                        <p className='sf-label'>{branch.branch}</p>
                                    </label>
                                ))}
                        </div>
                    </div>

                    <div className='sf-card mb-3'>
                        <div className="sf-head">
                            <span className="sf-title">State</span>
                            <button className="sf-clear" onClick={() => clearFilter("state")}>Clear</button>
                        </div>
                        <input
                            type="text"
                            placeholder="Search State"
                            className="filter-search"
                            value={stateSearch}
                            onChange={(e) => setStateSearch(e.target.value)}
                        />
                        <div className="seicon-st"><SvgContent svg_name="search_icon" stroke="#ababab" /></div>

                        <div className="sf-body">
                            {state && state
                                ?.filter((item) =>
                                    item.state.toLowerCase().includes(stateSearch.toLowerCase())
                                ).map((item) => (
                                    <label key={item.id} className="custom-checkbox">
                                        <input type="checkbox"
                                            checked={selectedFilters.state.some(
                                                (selected) => selected.value === item.state
                                            )}
                                            onChange={() => handleCheckboxChange("state", item.state, item.id)} />
                                        <span className="checkmark"></span>
                                        <p className='sf-label'>{item.state}</p>
                                    </label>
                                ))}
                        </div>
                    </div>

                    <div className='sf-card mb-3'>
                        <div className="sf-head">
                            <span className="sf-title">City</span>
                            <button className="sf-clear" onClick={() => clearFilter("city")}>Clear</button>
                        </div>
                        <input
                            type="text"
                            placeholder="Search City"
                            className="filter-search"
                            value={citySearch}
                            onChange={(e) => setCitySearch(e.target.value)}
                        />
                        <div className="seicon-st"><SvgContent svg_name="search_icon" stroke="#ababab" /></div>

                        <div className="sf-body">
                            {city && city
                                ?.filter((item) =>
                                    item.city.toLowerCase().includes(citySearch.toLowerCase())
                                ).map((item) => (
                                    <label key={item.id} className="custom-checkbox">
                                        <input type="checkbox"
                                            checked={selectedFilters.city.some(
                                                (selected) => selected.value === item.city
                                            )}
                                            onChange={() => handleCheckboxChange("city", item.city, item.id)} />
                                        <span className="checkmark"></span>
                                        <p className='sf-label'>{item.city}</p>
                                    </label>
                                ))}
                        </div>
                    </div>

                    <div className='sf-card mb-3'>
                        <div className="sf-head">
                            <span className="sf-title">Exam Accepted</span>
                            <button className="sf-clear" onClick={() => clearFilter("exams")}>Clear</button>
                        </div>
                        <input
                            type="text"
                            placeholder="Search Exams"
                            className="filter-search"
                            value={examsSearch}
                            onChange={(e) => setExamsSearch(e.target.value)}
                        />
                        <div className="seicon-st"><SvgContent svg_name="search_icon" stroke="#ababab" /></div>

                        <div className="sf-body">
                            {exams && exams
                                ?.filter((item) =>
                                    item.title.toLowerCase().includes(examsSearch.toLowerCase())
                                ).map((item) => (
                                    <label key={item.id} className="custom-checkbox">
                                        <input type="checkbox"
                                            checked={selectedFilters.exams.some(
                                                (selected) => selected.value === item.title
                                            )}
                                            onChange={() => handleCheckboxChange("exams", item.title, item.id)} />
                                        <span className="checkmark"></span>
                                        <p className='sf-label'>{item.title}</p>
                                    </label>
                                ))}
                        </div>
                    </div>

                    <div className='sf-card mb-3'>
                        <div className="sf-head">
                            <span className="sf-title">Accept Application</span>
                            <button className="sf-clear" onClick={() => clearFilter("application")}>Clear</button>
                        </div>

                        <div className="sf-body" style={{ height: "fit-content" }}>
                            {appliAccept && appliAccept.map((item, i) => (
                                <label key={i} className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={selectedFilters.application.some(
                                            (selected) => selected.value === item.name
                                        )}
                                        onChange={() => handleCheckboxChange("application", item.name, item.id)}
                                    />
                                    <span className="checkmark"></span>
                                    <p className='sf-label'>{item.name}</p>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>

                <div className='d-flex w-100'>
                    <button style={{ background: "linear-gradient(#eb5656, #fc2832)" }} onClick={handleReset} className='applybtnfilter-st w-50' >
                        <span className="letter">C</span>
                        <span className="letter">L</span>
                        <span className="letter">E</span>
                        <span className="letter">A</span>
                        <span className="letter">R</span>
                    </button>
                    <button className='applybtnfilter-st w-50' onClick={handleApply}>
                        <span className="letter">A</span>
                        <span className="letter">P</span>
                        <span className="letter">P</span>
                        <span className="letter">L</span>
                        <span className="letter">Y</span>
                    </button>
                </div>

            </div>
        </div>
    )
}

export default FilterModal
